<div [id]="'pieChart_' + id">
  <div [id]="'pie-chart_' + id"></div>
</div>
